import { formatMonthDayYear } from '~/common/helpers/utils';

const EM_DASH = '—';

export function formatEffectiveDates(from?: string, to?: string): string {
    if (!from && !to) {
        return EM_DASH;
    }
    const formattedFrom = from ? formatMonthDayYear(from) : 'N/A';
    const formattedTo = to ? formatMonthDayYear(to) : '';
    return `${formattedFrom} - ${formattedTo}`;
}
